import React, { createContext, useContext, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

type LanguageSelectionContextValue = {
  selectedFlag: string;
  setSelectedFlag: (flag: string) => void;
};

const LanguageSelectionContext = createContext<LanguageSelectionContextValue | undefined>(undefined);

export const LanguageSelectionProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { i18n } = useTranslation();
  const [selectedFlag, setSelectedFlagState] = useState(i18n.language);
  const selectedFlagRef = useRef(i18n.language);

  const setSelectedFlag = (flag: string) => {
    selectedFlagRef.current = flag;
    setSelectedFlagState(flag);
  };

  useEffect(() => {
    const onLanguageChanged = (language: string) => {
      if (selectedFlagRef.current !== 'be') {
        setSelectedFlag(language);
      }
    };

    i18n.on('languageChanged', onLanguageChanged);
    return () => i18n.off('languageChanged', onLanguageChanged);
  }, [i18n]);

  return (
    <LanguageSelectionContext.Provider value={{ selectedFlag, setSelectedFlag }}>
      {children}
    </LanguageSelectionContext.Provider>
  );
};

export const useLanguageSelection = () => {
  const context = useContext(LanguageSelectionContext);
  if (!context) {
    throw new Error('useLanguageSelection doit être utilisé à l’intérieur de LanguageSelectionProvider');
  }
  return context;
};
